import { Model } from "@/models/base/model";

export default class DailyNote extends Model {
  private baseUrl = "/cms/api/my-report/daily-note"; // ベースURL

  // コンストラクタ
  constructor(params: any = {}) {
    super(params);
    this.url = this.baseUrl;
  }

  // 症状・こころノートの取得
  async getData(month: string): Promise<any> {
    this.url = `${this.baseUrl}?month=${month}`;
    return await super.fetch();
  }
}
